import {
  COMPACT_NAV_DESKTOP_MEDIA_QUERY,
  COMPACT_NAV_MAX_WIDTH_PX,
  COMPACT_NAV_MEDIA_QUERY
} from "./navBreakpoint";

/**
 * Viewer compact / handheld layout — same breakpoint as marketing compact nav
 * (≤980px). Use for CSS `@media` and any `matchMedia` checks.
 */
export const VIEWER_MOBILE_MAX_WIDTH_PX = COMPACT_NAV_MAX_WIDTH_PX;

export const VIEWER_MOBILE_MEDIA_QUERY = COMPACT_NAV_MEDIA_QUERY;

export const VIEWER_DESKTOP_MEDIA_QUERY = COMPACT_NAV_DESKTOP_MEDIA_QUERY;

/** Set on `document.body` for mobile canvas “immersion” (nav bars slid off-screen). */
export const VIEWER_MOBILE_IMMERSED_BODY_CLASS = "viewer-mobile-immersed";

/** Desktop canvas drag/zoom — viewer chrome fades to 0% opacity. */
export const VIEWER_DESKTOP_CANVAS_DIM_BODY_CLASS = "viewer-desktop-canvas-dim";

/** Create Illustration — hides viewer HUD / inspector chrome until exit. */
export const ILLUSTRATION_MODE_BODY_CLASS = "illustration-mode";
